export default "__VITE_ASSET__CqNPTsem__"